"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var __2 = require("../../..");
var Fields_1 = require("../../ClientForm/Fields");
var EligibilityInput_1 = __importDefault(require("../ClientForm/Fields/EligibilityInput"));
var ReferralFormBody = function () {
    var _a = __2.useSemantics(), trans = _a.trans, options = _a.options;
    var _b = formik_1.useFormikContext(), errors = _b.errors, values = _b.values;
    var refOrgPrefix = 'project:slhh::enum.referrer-organisation';
    var moreOrgs = ['local', 'social', 'health_worker', 'community', 'other'];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Fields_1.ConsentToContactInput, null),
        react_1.default.createElement("div", { className: "my-6 border-b-3 border-gray-light" }),
        react_1.default.createElement(__1.FormControl, { errors: errors.title, label: trans('optiiva::labels.title') },
            react_1.default.createElement(__1.Select, { width: "xs", options: options.titles(), name: "title" })),
        react_1.default.createElement(Fields_1.FirstNameInput, null),
        react_1.default.createElement(Fields_1.LastNameInput, null),
        react_1.default.createElement(Fields_1.EmailInput, null),
        react_1.default.createElement(Fields_1.PhonePrimaryInput, null),
        react_1.default.createElement("div", { className: "my-6 border-b-3 border-gray-light" }),
        react_1.default.createElement(__1.FormControl, { errors: errors.borough || [], label: trans('project:slhh::labels.london-borough') },
            react_1.default.createElement(__1.Select, { width: "xs", name: "borough", options: {
                    bexley: trans('project:slhh::enum.borough.bexley'),
                    bromley: trans('project:slhh::enum.borough.bromley'),
                    croydon: trans('project:slhh::enum.borough.croydon'),
                    greenwich: trans('project:slhh::enum.borough.greenwich'),
                    kingston: trans('project:slhh::enum.borough.kingston'),
                    lambeth: trans('project:slhh::enum.borough.lambeth'),
                    lewisham: trans('project:slhh::enum.borough.lewisham'),
                    merton: trans('project:slhh::enum.borough.merton'),
                    richmond: trans('project:slhh::enum.borough.richmond'),
                    southwark: trans('project:slhh::enum.borough.southwark'),
                    sutton: trans('project:slhh::enum.borough.sutton'),
                    wandsworth: trans('project:slhh::enum.borough.wandsworth'),
                } })),
        react_1.default.createElement(__1.FormControl, { label: trans('optiiva::labels.housing-tenure') },
            react_1.default.createElement(__1.Select, { width: "xs", name: "housing_tenure", options: options.housingTenures() })),
        react_1.default.createElement(__1.FormControl, { errors: errors.line_1, label: trans('optiiva::labels.address-line-1') },
            react_1.default.createElement(__1.Input, { name: "line_1", maxLength: 200 })),
        react_1.default.createElement(__1.FormControl, { errors: errors.line_2, label: trans('optiiva::labels.address-line-2') },
            react_1.default.createElement(__1.Input, { name: "line_2", maxLength: 200 })),
        react_1.default.createElement(__1.FormControl, { errors: errors.town, label: trans('optiiva::labels.address-town') },
            react_1.default.createElement(__1.Input, { width: "sm", name: "town", maxLength: 200 })),
        react_1.default.createElement(__1.FormControl, { label: trans('optiiva::labels.address-postcode') },
            react_1.default.createElement(__1.Input, { width: "xs", name: "postcode", maxLength: 12 })),
        react_1.default.createElement("div", { className: "my-6 border-b-3 border-gray-light" }),
        react_1.default.createElement(EligibilityInput_1.default, null),
        react_1.default.createElement(__1.FormControl, { errors: errors.additional_information, label: trans('project:slhh::labels.referral-additional-information') },
            react_1.default.createElement(__1.TextArea, { name: "additional_information" })),
        react_1.default.createElement("div", { className: "my-6 border-b-3 border-gray-light" }),
        react_1.default.createElement(__1.FormControl, { errors: errors.referrer_name, label: trans('project:slhh::labels.referrer-name') },
            react_1.default.createElement(__1.Input, { name: "referrer_name", maxLength: 200 })),
        react_1.default.createElement(__1.FormControl, { errors: errors.referrer_phone, label: trans('project:slhh::labels.referrer-phone') },
            react_1.default.createElement(__1.Input, { name: "referrer_phone", maxLength: 200 })),
        react_1.default.createElement(__1.FormControl, { errors: errors.referrer_email, label: trans('project:slhh::labels.referrer-email') },
            react_1.default.createElement(__1.Input, { name: "referrer_email", maxLength: 200 })),
        react_1.default.createElement(__1.FormControl, { errors: errors.referrer_organisation || [], label: trans('project:slhh::labels.referrer-organisation'), other: react_1.default.createElement(__1.FormControl, { label: trans('optiiva::labels.other') },
                react_1.default.createElement(__1.TextArea, { name: "referrer_organisation_other" })), showOther: values.referrer_organisation
                ? moreOrgs.indexOf(values.referrer_organisation) > -1
                : false },
            react_1.default.createElement(__1.Select, { width: "xs", name: "referrer_organisation", options: {
                    local: trans(refOrgPrefix + ".local"),
                    social: trans(refOrgPrefix + ".social"),
                    health_worker: trans(refOrgPrefix + ".health_worker"),
                    community: trans(refOrgPrefix + ".community"),
                    groundworks: trans(refOrgPrefix + ".groundworks"),
                    thinking_works: trans(refOrgPrefix + ".thinking_works"),
                    selce: trans(refOrgPrefix + ".selce"),
                    other: trans(refOrgPrefix + ".other"),
                } }))));
};
var ReferralForm = function (_a) {
    var onSubmit = _a.onSubmit;
    var initialValues = {
        consent: null,
        phone_number: '',
        first_name: '',
        last_name: '',
        email: '',
        line_1: '',
        line_2: '',
        town: '',
        postcode: '',
        additional_information: '',
        borough: '',
        housing_tenure: '',
        referrer_name: '',
        referrer_phone: '',
        referrer_email: '',
        referrer_organisation: '',
        referrer_organisation_other: '',
        title: '',
        eligibility: [],
    };
    return (react_1.default.createElement("div", { className: "flex content-center items-center justify-center min-h-screen relative" },
        react_1.default.createElement("div", { className: "app-layout__bg" }),
        react_1.default.createElement("div", { className: "w-full max-w-lg mx-auto relative z-10 py-8" },
            react_1.default.createElement(__1.FormProvider, { initialValues: initialValues, onSubmit: onSubmit, validateOnChange: false, validateOnBlur: false }, function (form) { return (react_1.default.createElement(__1.Form, null,
                react_1.default.createElement(__1.Card, { heading: "South London Healthy Homes", footer: react_1.default.createElement(__1.Button, { processing: form.isSubmitting, type: __1.ButtonType.submit }, "Submit referral") },
                    react_1.default.createElement("div", null, "Living in a cold home is bad for your health and quality of life. The South London Stay Warm and Well Network offers practical support for vulnerable households at risk of the cold. We can help you cut the cost of heating your home and stay warm this winter."),
                    react_1.default.createElement("div", { className: "my-6 border-b-3 border-gray-light" }),
                    react_1.default.createElement(ReferralFormBody, null)))); }))));
};
exports.default = ReferralForm;
//# sourceMappingURL=ReferralForm.js.map